<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span
            class="mt-2 secondary--text"
          >{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-card class="mb-5">
            <v-form>
              <v-card-title class="pb-0">
                <v-layout row wrap>
                  <div>
                    <h3>Merchant Details</h3>
                  </div>
                  <v-spacer></v-spacer>

                  <v-flex justify-end pr-3 v-if="!add_location">
                    <v-btn class="primary" @click="add_location = true">Add New Location</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-title>

              <v-card-text class="pt-0 mt-4">
                <v-form>
                  <v-layout row wrap mt-4>
                    <v-flex xs12 sm6 pa-2>
                      <v-layout column>
                        <label class="pt-3">Merchant Name</label>
                        <v-text-field solo v-model="newMerchant.name" label="Merchant Name"></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 pa-2>
                      <v-layout column>
                        <label class="pt-3">Phone No</label>
                        <v-text-field solo v-model="newMerchant.phone" label="Phone number"></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 pa-2>
                      <v-layout column>
                        <label class="pt-3">Category</label>
                        <v-autocomplete
                          solo
                          v-model="newMerchant.category"
                          :items="categories"
                          item-text="name"
                          item-value="value"
                          label="Category"
                        ></v-autocomplete>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 pa-2>
                      <v-layout column>
                        <label class="pt-3">Business Type</label>
                        <v-autocomplete
                          label="Business Type"
                          solo
                          v-model="newMerchant.business_type"
                        ></v-autocomplete>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-expansion-panel popout>
                  <v-expansion-panel-content
                    v-for="(location,index) in newMerchant.locations"
                    :key="index"
                  >
                    <div slot="header">
                      <h3 v-text="location.address ? location.address : 'Location '+index+1"></h3>
                    </div>
                    <v-card>
                      <v-card-text class="activegrey">
                        <v-layout row wrap>
                          <v-form>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 px-3>
                                <div class="full-width">
                                  <label>Merchant Address</label>
                                  <v-flex>
                                    <v-textarea v-model="location.address" solo></v-textarea>
                                  </v-flex>
                                </div>
                              </v-flex>
                              <v-flex xs12 sm6 px-3>
                                <div class="full-width">
                                  <label>Assigned Marshal</label>
                                  <v-flex>
                                    <v-text-field v-model="location.marshal_name" solo></v-text-field>
                                  </v-flex>
                                </div>
                              </v-flex>
                              <v-flex xs12 sm6 px-3>
                                <div class="full-width">
                                  <label>Route</label>
                                  <v-flex>
                                    <v-text-field v-model="location.route" solo></v-text-field>
                                  </v-flex>
                                </div>
                              </v-flex>
                              <v-flex xs12 sm6 px-3>
                                <div class="full-width">
                                  <label>Area</label>
                                  <v-flex>
                                    <v-text-field v-model="location.area" solo></v-text-field>
                                  </v-flex>
                                </div>
                              </v-flex>
                              <v-flex xs12 sm6 px-3>
                                <div class="full-width">
                                  <label>Attendant Name</label>
                                  <v-flex>
                                    <v-text-field v-model="location.attendant_name" solo></v-text-field>
                                  </v-flex>
                                </div>
                              </v-flex>
                              <v-flex xs12 sm6 px-3>
                                <div class="full-width">
                                  <label>Attendant Phone</label>
                                  <v-flex>
                                    <v-text-field v-model="location.attendant_phone" solo></v-text-field>
                                  </v-flex>
                                </div>
                              </v-flex>
                              <v-flex xs12 sm6 px-3>
                                <div class="full-width">
                                  <label>Visitation</label>
                                  <v-flex>
                                    <v-select
                                      v-model="location.visitation"
                                      solo
                                      :items="visitations"
                                      item-text="name"
                                      item-value="value"
                                    ></v-select>
                                  </v-flex>
                                </div>
                              </v-flex>
                              <v-flex xs12 sm6 px-3>
                                <div class="full-width">
                                  <label>Visits this month</label>
                                  <v-flex>
                                    <v-text-field v-model="location.visits_this_month" solo></v-text-field>
                                  </v-flex>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-form>

                          <v-expansion-panel>
                            <v-expansion-panel-content
                              v-for="(terminal,tIndex) in location.terminals"
                              :key="tIndex"
                              class="primary mb-1 br-2"
                            >
                              <div
                                slot="header"
                                class="white--text"
                              >Terminal {{ tIndex+1 }} - {{ terminal.terminal_uuid }}</div>
                              <v-form>
                                <v-card dark color="#666">
                                  <v-card-text class="activegrey lighten">
                                    <v-layout row wrap>
                                      <v-flex xs12 sm6 px-3>
                                        <div class="full-width">
                                          <label>Terminal ID</label>
                                          <v-flex>
                                            <v-text-field v-model="terminal.terminal_uuid" solo></v-text-field>
                                          </v-flex>
                                        </div>
                                      </v-flex>
                                      <v-flex xs12 sm6 px-3>
                                        <div class="full-width">
                                          <label>Serial No</label>
                                          <v-flex>
                                            <v-text-field v-model="terminal.serial_no" solo></v-text-field>
                                          </v-flex>
                                        </div>
                                      </v-flex>
                                      <v-flex xs12 sm6 px-3>
                                        <div class="full-width">
                                          <label>Merchant ID</label>
                                          <v-flex>
                                            <v-text-field v-model="terminal.merchant_uuid" solo></v-text-field>
                                          </v-flex>
                                        </div>
                                      </v-flex>
                                      <v-flex xs12 sm6 px-3>
                                        <div class="full-width">
                                          <label>Terminal Type</label>
                                          <v-flex>
                                            <v-autocomplete
                                              v-model="terminal.terminal_type"
                                              solo
                                              :items="terminalTypes"
                                              item-text="rep"
                                              item-value="id"
                                            ></v-autocomplete>
                                          </v-flex>
                                        </div>
                                      </v-flex>
                                      <v-flex xs12 sm6 px-3>
                                        <div class="full-width">
                                          <label>Terminal App</label>
                                          <v-flex>
                                            <v-autocomplete
                                              v-model="terminal.terminal_app"
                                              solo
                                              :items="terminalApps"
                                              item-text="rep"
                                              item-value="id"
                                            ></v-autocomplete>
                                          </v-flex>
                                        </div>
                                      </v-flex>
                                      <v-flex xs12 sm6 px-3>
                                        <div class="full-width">
                                          <label>Bank</label>
                                          <v-flex>
                                            <v-autocomplete
                                              v-model="terminal.bank"
                                              solo
                                              :items="banks"
                                              item-text="name"
                                              item-value="id"
                                            ></v-autocomplete>
                                          </v-flex>
                                        </div>
                                      </v-flex>
                                    </v-layout>
                                  </v-card-text>
                                </v-card>
                              </v-form>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-layout>
                      </v-card-text>

                      <v-card-actions>
                        <v-flex justify-end px-3 mb-3>
                          <v-btn color="error" @click="removeLocation(index)">Remove</v-btn>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-card-text>
              <v-card-actions v-if="!add_location">
                <v-flex justify-center mb-3>
                  <v-btn color="success" @click="addNewMerchant">Create Merchant</v-btn>
                </v-flex>
              </v-card-actions>
            </v-form>
          </v-card>

          <v-card class="py-4" v-if="add_location">
            <v-card-title>
              <div>
                <h3>Add Location Details</h3>
              </div>
            </v-card-title>
            <v-card-text class="activegrey">
              <v-form>
                <v-layout row wrap>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 px-3>
                      <div class="full-width">
                        <label>Merchant Address</label>
                        <v-flex>
                          <v-textarea v-model="locationEdits.address" solo></v-textarea>
                        </v-flex>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <div class="full-width">
                        <label>Assigned Marshal</label>
                        <v-flex>
                          <v-text-field v-model="locationEdits.marshal_name" solo></v-text-field>
                        </v-flex>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <div class="full-width">
                        <label>Route</label>
                        <v-flex>
                          <v-text-field v-model="locationEdits.route" solo></v-text-field>
                        </v-flex>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <div class="full-width">
                        <label>Area</label>
                        <v-flex>
                          <v-text-field v-model="locationEdits.area" solo></v-text-field>
                        </v-flex>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <div class="full-width">
                        <label>Attendant Name</label>
                        <v-flex>
                          <v-text-field v-model="locationEdits.attendant_name" solo></v-text-field>
                        </v-flex>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <div class="full-width">
                        <label>Attendant Phone</label>
                        <v-flex>
                          <v-text-field v-model="locationEdits.attendant_phone" solo></v-text-field>
                        </v-flex>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <div class="full-width">
                        <label>Visitation</label>
                        <v-flex>
                          <v-select
                            v-model="locationEdits.visitation"
                            solo
                            :items="visitations"
                            item-text="name"
                            item-value="value"
                          ></v-select>
                        </v-flex>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 px-3>
                      <div class="full-width">
                        <label>Visits this month</label>
                        <v-flex>
                          <v-text-field v-model="locationEdits.visits_this_month" solo></v-text-field>
                        </v-flex>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-expansion-panel :expand="false">
                    <v-expansion-panel-content
                      v-for="(tid,tIndex) in locationEdits.terminals"
                      :key="tIndex"
                      class="primary mb-1 br-2"
                    >
                      <div
                        slot="header"
                        class="white--text"
                      >Terminal {{ tIndex+1 }} - {{ tid.terminal_uuid }}</div>
                      <v-card dark color="#666">
                        <v-card-text class="activegrey lighten">
                          <v-layout row wrap>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Terminal ID</label>
                                <v-flex>
                                  <v-text-field required v-model="tid.terminal_uuid" solo></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Serial No</label>
                                <v-flex>
                                  <v-text-field v-model="tid.serial_no" solo></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Merchant ID</label>
                                <v-flex>
                                  <v-text-field v-model="tid.merchant_uuid" solo></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Terminal Type</label>
                                <v-flex>
                                  <v-autocomplete
                                    v-model="tid.terminal_type"
                                    solo
                                    :items="terminalTypes"
                                  ></v-autocomplete>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Terminal App</label>
                                <v-flex>
                                  <v-autocomplete
                                    v-model="tid.terminal_app"
                                    solo
                                    :items="terminalApps"
                                  ></v-autocomplete>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Bank</label>
                                <v-flex>
                                  <v-autocomplete v-model="tid.bank" solo :items="banks"></v-autocomplete>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 justify-end px-3 pb-3>
                              <v-btn color="error" @click="removeTerminal(tIndex)">REMOVE</v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <div class="mt-3" v-if="add_terminal">
                    <div class="white--text primary pa-3">
                      <h2 class="font-weight-light">New Terminal</h2>
                    </div>
                    <v-form>
                      <v-card dark color="#666">
                        <v-card-text class="activegrey lighten">
                          <v-layout row wrap>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Terminal ID</label>
                                <v-flex>
                                  <v-text-field v-model="terminalEdits.terminal_uuid" solo></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Serial No</label>
                                <v-flex>
                                  <v-text-field v-model="terminalEdits.serial_no" solo></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Merchant ID</label>
                                <v-flex>
                                  <v-text-field v-model="terminalEdits.merchant_uuid" solo></v-text-field>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Terminal Type</label>
                                <v-flex>
                                  <v-autocomplete
                                    v-model="terminalEdits.terminal_type"
                                    solo
                                    :items="terminalTypes"
                                    item-text="rep"
                                    item-value="id"
                                  ></v-autocomplete>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Terminal App</label>
                                <v-flex>
                                  <v-autocomplete
                                    v-model="terminalEdits.terminal_app"
                                    solo
                                    :items="terminalApps"
                                    item-text="rep"
                                    item-value="id"
                                  ></v-autocomplete>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 px-3>
                              <div class="full-width">
                                <label>Bank</label>
                                <v-flex>
                                  <v-autocomplete v-model="terminalEdits.bank" solo :items="banks"></v-autocomplete>
                                </v-flex>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                        <v-card-actions class="pr-4 pb-4">
                          <v-flex justify-end>
                            <v-btn color="error lighten-5" flat @click="add_terminal = false">Cancel</v-btn>
                            <v-btn color="success" @click="addNewTerminal">Add</v-btn>
                          </v-flex>
                        </v-card-actions>
                      </v-card>
                    </v-form>
                  </div>
                  <v-flex justify-end mt-2 v-else>
                    <v-btn color="success" @click="add_terminal = true">Add New Terminal</v-btn>
                  </v-flex>
                </v-layout>

                <v-flex justify-center mt-4>
                  <v-btn color="error" flat @click="add_location = false">CANCEL</v-btn>
                  <v-btn color="primary" @click="addNewLocation">Add Location</v-btn>
                </v-flex>
              </v-form>
            </v-card-text>
          </v-card>
          <v-snackbar
            v-model="snackbar.show"
            bottom
            right
            :color="snackbar.color"
            :timeout="snackbar.timeout"
          >
            {{ snackbar.message }}
            <v-flex justify-end>
              <!-- <v-btn flat v-if="notification.url" :to="notification.url" @click="hideSnackbar">Go to</v-btn> -->
              <v-btn flat @click="snackbar.show = false">Close</v-btn>
            </v-flex>
          </v-snackbar>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AdminLayout from "../../../layouts/admin"
import utils from "@/common/utils"

export default {
  name: "CreateMerchantLocation",
  data() {
    return {
      page_title: "New Merchant Location",
      getDate: new Date(),
      merchantDialog: false,
      panel: [],
      snackbar: {
        show: false,
        message: "",
        color: "",
        timeout: 3000
      },
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      newMerchant: {
        name: "Good Home Ventures",
        category: "Top 10%",
        business_type: "",
        phone: "07030000999",
        locations: []
      },
      locationEdits: {
        address: "",
        marshal: "",
        route: "",
        area: "",
        attendant_name: "",
        attendant_phone: "",
        visitation: "",
        visits_this_month: "",
        terminals: []
      },
      terminalEdits: {
        terminal_uuid: "",
        serial_no: "",
        merchant_uuid: "",
        terminal_type: "",
        terminal_app: "",
        bank: ""
      },
      terminalApps: ["NEX90", "CitiServe", "GlobalAccelerex"],
      terminalTypes: ["NEX10", "CitiServe", "GlobalAccelerex", "Winelight"],
      visitations: ["Once a week", "Twice a week", "Once a month"],
      banks: ["Access Bank", "Union Bank", "UBA"],
      add_terminal: true,
      add_location: true
    }
  },
  computed: {
    categories: function() {
      return utils.CATEGORY_CHOICES
    }
  },
  methods: {
    goToLocation() {
      this.$router.push(`/admin/create/merchantLocation`)
    },
    addNewTerminal() {
      this.locationEdits.terminals.push(this.terminalEdits)
      this.showSnackbar(
        "New Terminal " +
          this.terminalEdits.terminal_uuid +
          " Successfully Added!",
        "success"
      )
      this.terminalEdits = {}
      this.add_terminal = false
    },
    removeTerminal(index) {
      this.locationEdits.terminals.splice(index, 1)
    },
    addNewLocation() {
      this.newMerchant.locations.push(this.locationEdits)
      this.showSnackbar(
        "New Location " +
          this.newMerchant.locations.address +
          " Successfully Added!",
        "primary"
      )
      this.locationEdits = {}
      this.add_location = false
    },
    removeLocation(index) {
      this.newMerchant.locations.splice(index, 1)
    },
    addNewMerchant() {
      //   this.$router.push("/admin", function() {
      this.showSnackbar(
        "New Merchant " + this.newMerchant.name + " Successfully Added!",
        "success"
      )
      //   })
    },
    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.color = color
      this.snackbar.show = true
    }
  },
  created() {
    this.$emit("update:layout", AdminLayout)
  }
}
</script>


